import React from "react";
import { useState, useEffect, useRef } from 'react'
import ReactEcharts from "echarts-for-react";
import * as Constants from "../Constants";

function LegalOrgChart() {
  // const [data, setData] = useState({})
  const [gotData, setGotData] = useState(false);
  // const [data, setData] = useState({
  //   "Loading...1": {
  //     "Loading... 2": {
  //       "Loading...  3": {},
  //       "Loading...  7": {}
  //     },
  //     "Loading...   4": {
  //       "Loading...     5": {},
  //       "Loading...      6": {}
  //     }
  //   }
  // });
  const [data, setData] = useState({
    "Loading...": {}
  });
  const ref = useRef(0);
  const differential = 100;

  const get_legal_chart_api = async () => {
    if (Constants.use_api) {
      try {
        const res = await fetch(`${Constants.url}/api/v1/section108/get_legal_chart/${Constants.company_name}`)
        if (res.ok) {
          const dataResponse = await res.json()
          setGotData(true);
          return dataResponse
        } else {
          console.log("ERROR: Something went wrong in get_legal_chart_api response LegalOrgChart. res:")
          console.log(res)
          return null
        }
      } catch (error) {
        console.log("ERROR: Something went wrong in get_legal_chart_api response LegalOrgChart.")
        return null
      }
    } else {
      await Constants.sleep(Constants.sleep_for_api_testing);
      setGotData(true);
      console.log("WARNING: Using fake data from Constants file in get_legal_chart_api API call.")
      return Constants.get_legal_chart_api_data
    }
  }

  useEffect(() => {
    get_legal_chart_api().then(dataResponse => setData(dataResponse))
    // console.log('width', ref.current, ref.current.offsetWidth);
  }, [ref.current]);

  var node_data = []
  var link_data = []

  function traverse_entity_children(parent, entity, x_differential, y_differential) {
    node_data.push({
      name: parent,
      x: x_differential,
      y: y_differential
    })
    var add_to_x = 0
    // const number_of_children = Object.entries(entity).length
    var number_of_children_running = 0
    for (const [key, value] of Object.entries(entity)) {
      link_data.push({
        source: parent,
        target: key
      })
      traverse_entity_children(key, value, x_differential + add_to_x, y_differential + differential)
      number_of_children_running += Object.entries(value).length
      if (number_of_children_running == 0) {
        add_to_x += differential
      } else {
        add_to_x += differential * number_of_children_running
      }
      
    }

    // for (var child in entity) {
    //   console.log("here2", parent, child, entity[child])
    //   for (const [key, value] of Object.entries(entity[child])) {
    //     console.log("here3", key, value)
    //     traverse_entity_children(key, value)
    //   }
      // link_data.concat({
      //   source: parent,
      //   target: 
      // })
    // }
  }

  
  for (const [key, value] of Object.entries(data)) {
    traverse_entity_children(key, value, differential, differential)
  }

  // console.log("node_data5", node_data)
  // console.log("link_data6", link_data)

  var option = {
    title: {
      text: gotData ? 'Legal Org Chart' : "Loading...",
    },
    tooltip: {},
    animationDurationUpdate: 1500,
    animationEasingUpdate: 'quinticInOut',
    series: [
      {
        type: 'graph',
        layout: 'none',
        symbolSize: 150,
        roam: true,
        label: {
          show: true
        },
        edgeSymbol: ['circle', 'arrow'],
        edgeSymbolSize: [4, 10],
        edgeLabel: {
          fontSize: 20
        },
        data: node_data,
        // data: [
        //   {
        //     name: 'Parent Inc.',
        //     x: ref.current.offsetWidth / 2,
        //     y: 0
        //   },
        //   {
        //     name: 'Parent In.',
        //     x: ref.current.offsetWidth / 2 - differential,
        //     y: differential
        //   },
        //   {
        //     name: 'Node 3',
        //     x: ref.current.offsetWidth / 2 + differential,
        //     y: differential
        //   },
        //   //   {
        //   //     name: 'Node 4',
        //   //     x: ref.current.offsetWidth/2-200,
        //   //     y: 2*differential
        //   //   }
        // ],
        links: link_data,
        // links: [
        //   //   {
        //   //     source: 0,
        //   //     target: 1,
        //   //     symbolSize: [5, 20],
        //   //     label: {
        //   //       show: true
        //   //     },
        //   //     lineStyle: {
        //   //       width: 5,
        //   //       curveness: 0.2
        //   //     }
        //   //   },
        //   //   {
        //   //     source: 'Node 2',
        //   //     target: 'Parent Inc.',
        //   //     label: {
        //   //       show: true
        //   //     },
        //   //     lineStyle: {
        //   //       curveness: 0.2
        //   //     }
        //   //   },
        //   {
        //     source: 'Parent Inc.',
        //     target: 'Parent In.'
        //   },
        //   {
        //     source: 'Parent Inc.',
        //     target: 'Node 3'
        //   },
        //   //   {
        //   //     source: 'Node 2',
        //   //     target: 'Node 4'
        //   //   },
        //   //   {
        //   //     source: 'Parent Inc.',
        //   //     target: 'Node 4'
        //   //   }
        // ],
        lineStyle: {
          opacity: 0.9,
          width: 5,
          curveness: 0
        }
      }
    ]
  };
  return (
    <div style={{ height: '98vh', width: '94vw' }} ref={ref} >
      {(() => {
        if (data == null) {
          return (
            <p>Failed to load data.</p>
          )
        } else {
          return (
            <ReactEcharts option={option} style={{ height: '100%', width: '100%' }} />
          )
        }
      })()}
    </div>
  );
}

export default LegalOrgChart;